import { render, staticRenderFns } from "./candidate.vue?vue&type=template&id=1299b97d&"
import script from "./candidate.vue?vue&type=script&lang=js&"
export * from "./candidate.vue?vue&type=script&lang=js&"
import style0 from "./candidate.vue?vue&type=style&index=0&id=1299b97d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports